// Module catalog (mockup 3): active, trial, then not in your plan. Tapping a locked tile opens its page.
import { Link } from 'react-router';
import { listModules, moduleState, trialDaysLeft } from '@tradeview/core';
import { useAuth } from '../auth';
import { Icon } from '../app/Icon';
import { price } from '../lib/price';

export function Catalog() {
  const { session } = useAuth();
  const ent = session?.entitlements ?? null;
  const all = listModules();
  const on = all.filter(m => ['active', 'trial'].includes(moduleState(ent, m.manifest.id)));
  const off = all.filter(m => moduleState(ent, m.manifest.id) === 'locked');
  return (
    <div className="flex flex-col gap-2.5">
      <h2 className="font-disp font-bold text-[26px] leading-none m-0 pt-1.5">Modules</h2>
      <Link to="/guide" className="card flex items-center gap-3"><div className="ic ic-acc"><Icon name="report" size={18} /></div><div className="min-w-0 flex-1"><b className="block font-semibold">The Guide</b><small className="block text-muted text-[12.5px]">How we run a day in TradeView, by role, searchable</small></div><Icon name="chevron" size={16} className="text-muted" /></Link>
      <div className="card"><h4 className="lbl m-0 mb-1">Your plan</h4><div className="text-[14px]"><b className="font-head">{on.length} of {all.length}</b> modules on · prices are placeholders until the Phase 6 study</div></div>
      {on.length > 0 && <div className="lbl">Active</div>}
      {on.map(m => {
        const st = moduleState(ent, m.manifest.id); const days = trialDaysLeft(ent, m.manifest.id);
        return (
          <Link key={m.manifest.id} to={`/modules/${m.manifest.id}`} className={`tile ${st === 'trial' ? 'border-warn' : ''}`}>
            <div className={`ic ${st === 'trial' ? 'ic-warn' : 'ic-ok'}`}><Icon name={m.manifest.nav[0]?.icon ?? 'grid'} /></div>
            <div className="min-w-0 flex-1"><b className="block font-semibold">{m.manifest.name}</b><small className="block text-muted text-[12.5px] truncate">{m.manifest.marketing.tagline}</small></div>
            <span className={`pill pill-nodot ${st === 'trial' ? 'pill-warn' : 'pill-ok'}`}>{st === 'trial' ? `Trial · ${days} days` : 'On'}</span>
          </Link>
        );
      })}
      {off.length > 0 && <div className="lbl mt-1">Not in your plan</div>}
      {off.map(m => (
        <Link key={m.manifest.id} to={`/modules/${m.manifest.id}`} className="tile tile-locked">
          <div className="ic ic-lock"><Icon name="lock" /></div>
          <div className="min-w-0 flex-1"><b className="block font-semibold">{m.manifest.name}</b><small className="block text-muted text-[12.5px] truncate">{m.manifest.marketing.tagline}</small></div>
          <span className="font-head font-bold text-[13px] text-right">{price(m.manifest.sku)}</span>
        </Link>
      ))}
    </div>
  );
}
